'use client'

import { createContext, useContext, useMemo, useState } from 'react'

interface IDirectoryHighlightedContext {
    highlightedIndex: number | null
    setHighlightedIndex: (index: number | null) => void
}

const DirectoryHighlightedContext = createContext<IDirectoryHighlightedContext>({
    highlightedIndex: null,
    setHighlightedIndex: () => {},
})

export const DirectoryHighlightedContextProvider = ({ children }: { children: React.ReactNode }) => {
    const enableHighlights = false as boolean

    const [highlightedIndex, setHighlightedIndex] = useState<number | null>(null)

    return (
        <DirectoryHighlightedContext.Provider
            value={useMemo(
                () => ({
                    highlightedIndex: enableHighlights ? highlightedIndex : null,
                    setHighlightedIndex,
                }),
                [enableHighlights, highlightedIndex, setHighlightedIndex]
            )}
        >
            {children}
        </DirectoryHighlightedContext.Provider>
    )
}

export const useDirectoryHighlightedContext = () => useContext(DirectoryHighlightedContext)
